export { AsyncComponentFallbackTemplate } from './AsyncComponentFallbackTemplate';
